module.exports = __webpack_public_path__ + "static/media/hotspot-ring.2522f556.png";